import Page from "components/Page"
import Content from "components/Content"
import SupportView from "components/SupportView"

const SupportPage = () => <Page title='Support'>
  <Content>
    <SupportView />
  </Content>
</Page>

export default SupportPage
